import type { TokenErrorReason } from 'shared/domain/auth/tokenErrorReason';

export class ServiceWorkerTokenRequestError extends Error {
  readonly reason: TokenErrorReason;

  constructor(reason: TokenErrorReason) {
    super(`Token error: ${reason}`);
    this.name = 'ServiceWorkerTokenRequestError';
    this.reason = reason;
  }
}

export function isServiceWorkerTokenRequestError(
  error: unknown
): error is ServiceWorkerTokenRequestError {
  return error instanceof ServiceWorkerTokenRequestError;
}

export function shouldEnterAuthCooldownOnTokenRequestError(
  error: unknown
): boolean {
  return !(
    isServiceWorkerTokenRequestError(error) &&
    error.reason === 'unauthenticated'
  );
}
